import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSummary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSummary"><Path d="M3.5 5.5V17.5H20" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 19V16L20.5 17.5L18.5 19Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 7.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12.5H13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSummary;
